var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase_part my-2" },
    [
      _c("cabinet-fl44-card-header", { attrs: { purchase: _vm.purchase } }),
      _c("cabinet-fl44-card-subheader", { attrs: { purchase: _vm.purchase } }),
      _c("cabinet-fl44-card-body", {
        scopedSlots: _vm._u([
          {
            key: "col1",
            fn: function () {
              return [
                _vm.purchase.flags.notice_approval_needed
                  ? [
                      _vm.purchase.actions.request_approval &&
                      !_vm.purchase.approval_info
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "font-weight-bold fs-14 m-0 pb-2 text-danger",
                            },
                            [_vm._v("Требуется согласование")]
                          )
                        : _vm.purchase.approval_info &&
                          _vm.purchase.approval_info.status
                        ? _c(
                            "p",
                            {
                              staticClass: "font-weight-bold fs-14 m-0 pb-2",
                              class: _vm.purchase.approval_info.status.class,
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.purchase.approval_info.status.title)
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm.purchase.status.id === "accepting" &&
                !!_vm.purchase.purchase_info.purchase_end
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "До окончания подачи предложений" } },
                      [
                        _c("timer-new", {
                          attrs: {
                            data: _vm.purchase.purchase_info.purchase_end,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.purchase.purchase_info.planned_end_date ??
                _vm.purchase.purchase_info.planned_contract_execution_date
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Планируемая дата исполнения" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.getDateFormat(
                              _vm.purchase.purchase_info.planned_end_date ??
                                _vm.purchase.purchase_info
                                  .planned_contract_execution_date
                            )
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.purchase.flags.is_customer
                  ? _c("purchase-comment-edit-block", {
                      attrs: {
                        purchase: _vm.purchase,
                        type: _vm.purchase.type,
                      },
                      on: { refresh: _vm.refresh },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "col2",
            fn: function () {
              return [
                _vm.purchase.purchase_info.purchase_name
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "Предмет закупки" } },
                      [_vm._v(_vm._s(_vm.purchase.purchase_info.purchase_name))]
                    )
                  : _vm._e(),
                _c(
                  "cabinet-notice-card-row-single",
                  { attrs: { label: "Количество позиций" } },
                  [
                    _vm._v(
                      _vm._s(_vm.purchase.purchase_info.deliverables_count)
                    ),
                  ]
                ),
                _vm.purchase.purchase_info.delivery_addresses &&
                _vm.purchase.purchase_info.delivery_addresses.length
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      {
                        attrs: {
                          label:
                            "Адреса для доставки товаров/выполнения работ/оказания услуг",
                        },
                      },
                      _vm._l(
                        _vm.purchase.purchase_info.delivery_addresses,
                        function (address, index) {
                          return _c(
                            "p",
                            {
                              key: `${_vm.purchase.id}_address_${index}`,
                              staticClass: "fs-12 m-0 grey-color fw-600",
                            },
                            [_vm._v("— " + _vm._s(address.address))]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "col3",
            fn: function () {
              return [
                _c("cabinet-fl44-unknown-volume-card-info-links", {
                  attrs: { purchase: _vm.purchase },
                }),
                _c(
                  "div",
                  { staticClass: "my-2" },
                  [
                    _c("cabinet-fl44-notice-card-edit-button", {
                      attrs: { purchase: _vm.purchase },
                    }),
                    _c("cabinet-fl44-notice-card-request-approval-button", {
                      attrs: { purchase: _vm.purchase },
                      on: { action: _vm.refresh },
                    }),
                    _c("cabinet-fl44-notice-card-publish-button", {
                      attrs: { purchase: _vm.purchase },
                      on: { action: _vm.refresh },
                    }),
                    _c("cabinet-fl44-notice-card-delete-button", {
                      attrs: { purchase: _vm.purchase },
                      on: { action: _vm.refresh },
                    }),
                    _c("cabinet-fl44-notice-card-prolong-button", {
                      attrs: { purchase: _vm.purchase },
                      on: { action: _vm.refresh },
                    }),
                    _c("cabinet-fl44-notice-card-cancel-button", {
                      attrs: { purchase: _vm.purchase },
                      on: { action: _vm.refresh },
                    }),
                    _c("cabinet-fl44-notice-card-unpublish-button", {
                      attrs: { purchase: _vm.purchase },
                      on: { action: _vm.refresh },
                    }),
                    _c("cabinet-fl44-notice-card-duration-change-button", {
                      attrs: { purchase: _vm.purchase },
                    }),
                    _c(
                      "cabinet-fl44-notice-card-answer-explanation-request-button",
                      { attrs: { purchase: _vm.purchase } }
                    ),
                    _c("cabinet-fl44-notice-card-store-protocol-button", {
                      attrs: { purchase: _vm.purchase },
                    }),
                    _c("cabinet-fl44-notice-card-copy-button", {
                      attrs: { purchase: _vm.purchase },
                    }),
                    _vm.purchase.actions.send_contract
                      ? _c(
                          "b-button",
                          {
                            staticClass:
                              "btn btn-card-action btn-card-action-danger my-1",
                            attrs: {
                              to: { ..._vm.link, hash: "#atmo-contract" },
                              target: "_blank",
                            },
                          },
                          [_vm._v(" Отправить контракт ")]
                        )
                      : _vm._e(),
                    _vm.purchase.actions.answer_dispute
                      ? _c(
                          "b-button",
                          {
                            staticClass:
                              "btn btn-card-action btn-card-action-danger my-1",
                            attrs: {
                              to: {
                                ..._vm.link,
                                hash: "#atmo-disputes-resolution",
                              },
                              target: "_blank",
                            },
                          },
                          [_vm._v(" Ответить на протокол разногласий ")]
                        )
                      : _vm._e(),
                    _vm.purchase.actions.sign_contract
                      ? _c(
                          "b-button",
                          {
                            staticClass:
                              "btn btn-card-action btn-card-action-danger my-1",
                            attrs: {
                              to: { ..._vm.link, hash: "#atmo-contract" },
                              target: "_blank",
                            },
                          },
                          [_vm._v(" Подписать контракт ")]
                        )
                      : _vm._e(),
                    _vm.purchase.actions.sign_supplementary_agreement
                      ? _c(
                          "b-button",
                          {
                            staticClass:
                              "btn btn-card-action btn-card-action-danger my-1",
                            attrs: {
                              to: {
                                ..._vm.link,
                                hash: "#atmo-contract-annexes",
                              },
                              target: "_blank",
                            },
                          },
                          [_vm._v(" Подписать дополнительное соглашение ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("cabinet-fl44-notice-card-block-info", {
                  attrs: { purchase: _vm.purchase },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }